import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LogsPage from './LogsPage';
import TransactionLogsFilters from '../components/systemLogs/transactionLogsFilters';

import { getTransactionLogList as getLogsList } from '../actions/systemLogActions';

class TransactionsLog extends React.Component {
    renderFilters = ({ pageSizes, filterLogs }) => {
        return (
            <TransactionLogsFilters
                pageSizes={pageSizes}
                filterLogs={filterLogs}
                products={this.props.products}
                markets={this.props.markets}
            />
        );
    };

    render() {
        return this.props.isPageVisible ? (
            <LogsPage
                renderFilters={this.renderFilters}
                title="Order log"
                logs={this.props.logs}
                hasMore={this.props.hasMore}
                getLogsList={this.props.getLogsList}
            />
        ) : null;
    }
}

TransactionsLog.propTypes = {
    getLogsList: PropTypes.func.isRequired,
    isPageVisible: PropTypes.bool.isRequired,
    logs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    hasMore: PropTypes.bool.isRequired,
    markets: PropTypes.arrayOf(PropTypes.shape({})),
    products: PropTypes.arrayOf(PropTypes.shape({})),
};

TransactionsLog.defaultProps = {
    markets: [],
    products: [],
};

export default connect(
    state => ({
        logs: state.systemlogs.transactionlogs,
        hasMore: state.systemlogs.hasMore,
        markets: state.markets.data,
        products: state.user.userInfo.products,
        isPageVisible: !!(state.user.isLoggedIn && state.user.isAdmin),
    }),
    {
        getLogsList,
    },
)(TransactionsLog);



// WEBPACK FOOTER //
// ./source/screens/TransactionLog.js